module.exports = __webpack_public_path__ + "img/TD365-logo.d8849594.png";